import classNames from 'classnames'
import React from 'react'

import Image from '@/components/Image'
import Link from '@/components/Link'

const RessourceLinks = ({card}) => {
  return (
    <div className='relative hidden flex-col gap-4 rounded-lg bg-violet-200 p-2 pb-6 lg:mb-4 lg:flex'>
      <div className=''>
        <div
          className={classNames(
            'misc-button-s fit-content absolute -top-3 left-1/2 flex -translate-x-1/2 rotate-6 rounded-lg px-2 py-1 uppercase',
            {
              'bg-purple-400 text-white': card.badgeColor === 'purple',
              'text-purple-700 bg-turquoise-400': card.badgeColor === 'turquoise',
              'bg-violet-400': card.badgeColor === 'violet',
              'bg-yellow-400 text-purple-900': card.badgeColor === 'yellow',
            }
          )}
        >
          {card.badge}
        </div>

        <div className='overflow-hidden rounded-s'>
          <Link link={card.link}>
            <Image {...card.image} sizes={{sm: '100', md: '50'}} fitIn />
          </Link>
        </div>
      </div>
      <div className='flex flex-col gap-2 px-2'>
        <div className='body-s-medium'>{card.heading}</div>
        <div className='body-xs-regular text-purple-400'>{card.content}</div>
        <div className='body-xs-regular text-purple-400'>{card.subHeading}</div>
        <div className='flex flex-col gap-2'>
          {card.links.map((link) => (
            <Link
              link={link.link}
              className='body-xs-regular space-between flex w-full items-center border-b border-violet-300 pb-2 text-purple-900'
            >
              <div className='flex w-full items-center justify-between'>
                {link.label}
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'
                >
                  <path
                    d='M8.63393 13.2797L14.034 7.92951L8.77612 2.72021M1.96606 7.92717L13.8361 7.92717'
                    stroke='#280C2D'
                    stroke-linecap='round'
                  />
                </svg>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RessourceLinks
